/* RESPONSIBLE TEAM: team-frontend-tech */
import { get, computed } from '@ember/object';

export default function (document_type) {
  return computed('baseAnalyticsMetadata', function () {
    let metadata = get(this, 'baseAnalyticsMetadata');
    return { ...metadata, document_type };
  });
}
